export class DumpsterListAddToGroupsInput {
  dumpsters: number[];
  groups: number[];

  constructor(dumpsters: number[], authorizationGroups: number[]) {
    this.dumpsters = dumpsters;
    this.groups = authorizationGroups;
  }
}
